import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { connect, useDispatch, useSelector } from "react-redux";
import { CallAgent, IncomingCall, Call } from "@azure/communication-calling";
import { AzureCommunicationTokenCredential, CommunicationUserIdentifier, CommunicationUserKind } from "@azure/communication-common";
import { HubConnection } from "@microsoft/signalr";
import { toast, ToastContainer } from "react-toastify";
import { Capacitor } from '@capacitor/core';

import * as serviceWorkerRegistration from './../../serviceWorkerRegistration';

import { auth_details, 
  reset_Call_State, 
  reset_States, 
  set_Call_Agent, 
  set_Call_Client, 
  set_call_connected, 
  set_Chat_Count, 
  set_chat_data, 
  set_Connection, 
  set_endpoint, 
  set_Incoming_Call, 
  set_Phone_Calling, 
  set_Thread_Id, 
  set_toggle_video_call,
  set_Token_Credential, 
  set_Total_Credit, 
  set_User_Identifier 
} from "../../reducer/auth";
import { acceptIncomingCall, detectIncomingCall, getConnection, getEndpoint, getSPProfileList, getTotalCredit, getUnReadAlldata } from "../../services/homeService";
import { LOCALSTORE } from "../../constant/default";
import IncomingAudioCall from "../../component/call/incoming-audio-call";
import IncomingVideoCall from "../call/incoming-video-call";
import { BroadcastTargetEnum, BroadcastTypeEnum, CallTypeEnum, RingtoneEnum, UserRoleEnum } from "../../enums/enum";
import { AcceptIncomingCallModel } from "../../models/communication-model";
import { createStatefulCallClient, fromFlatCommunicationIdentifier, StatefulCallClient } from "@azure/communication-react";
import { ChatClient } from "@azure/communication-chat";
import { ChatMessageReceivedEvent } from "@azure/communication-signaling";
import { getCallType, playRingTone, stopRingTone } from "../../functions/utilities";
import { reset_azure_communication_data } from "../../reducer/chatDataSlice";
import { CallNotificationModel, EventSignalRModel } from "../../models/signalR.model";
import { PublicProfileResponseModel } from "../../models/user-public-profile";
import { ValueModel } from "../../models/value.model";

const AzureCallAgent: React.FC<any> = (props: any) => {
  const navigate = useNavigate();
  const persistDispatch = useDispatch();
  const userDetail = useSelector(auth_details);
  const accountData = userDetail.accountData;
  const userProfile = userDetail.user_profile;
  const incomingCall: IncomingCall = userDetail.incomingCall;
    
  const [callType, setCallType] = useState(CallTypeEnum.AudioCall);
  const [isIncomingCall, setIncomingCallDialog] = useState(false);
  const [incomingCallUser, setIncomingCallUser] = useState<PublicProfileResponseModel>();
  const [currentSPProfile, setCurrentSPProfile] = useState<any>();
  const [hubConnection, setHubConnection] = useState<HubConnection>();
  const [call, setCall] = useState<Call>();
  const [isTabActive, setIsTabActive] = useState<boolean>();

  const spProfiles: string[] = [];

  // Init SignalR connection
  
  useEffect(() => {
    try {
      if (!userDetail?.login?.isSuccess) {
        if (!!hubConnection) {
          hubConnection.off(BroadcastTargetEnum.CallNotification, handleCallNotification);
          hubConnection.off(BroadcastTargetEnum.Notification, handleSignalRNotification);
        }
        return;
      }
      
      initSignalRConnection();
      initNotification();
      getunreadCount();

      const userRole = localStorage.getItem(LOCALSTORE.role) as any;
      
      // Save the current profile ID to localStorage for direct API calls
      if (userDetail?.user_profile?.id) {
        localStorage.setItem('currentProfileId', userDetail.user_profile.id);
        console.log("💾 Setting current profile ID in storage:", userDetail.user_profile.id);
      }
      
      if (userRole == UserRoleEnum.ServiceProvider) {
        getProfiles();
      } else {
        const communicationToken = localStorage.getItem(LOCALSTORE.communicationIdentifier.token) as any;
        const communicationUserId = localStorage.getItem(LOCALSTORE.communicationIdentifier.userId) as any;
        const expiredOn = localStorage.getItem(LOCALSTORE.communicationIdentifier.expiredOn);

        validate(communicationToken, communicationUserId, expiredOn);
        userInit(communicationToken, communicationUserId);
      }
      
      // Listen for direct incoming call detection events from native layer
      setupIncomingCallDetectionListener();
      
      // Check for any pending call notifications that might have been stored
      checkPendingCallNotifications();
    } catch (err) {
      // toast.error("Create call agent failed, please refresh the page.", { theme: "colored", autoClose: 3000 });
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetail?.login?.isSuccess]);
  
  // Function to check for any stored call notifications
  const checkPendingCallNotifications = () => {
    try {
      const pendingCallData = localStorage.getItem('pending_call_data');
      if (pendingCallData) {
        console.log("🔍 Found stored call notification data, processing...");
        try {
          const callData = JSON.parse(pendingCallData);
          console.log("🔍 Parsed pending call data:", callData);
          
          // Clear the stored data to prevent duplicate processing
          localStorage.removeItem('pending_call_data');
          
          // Process the call data
          const userRole = localStorage.getItem(LOCALSTORE.role) as any;
          if (userRole === UserRoleEnum.ServiceProvider) {
            handleServiceProviderCallDetection(callData);
          } else {
            handleUserCallDetection(callData);
          }
        } catch (e) {
          console.error("❌ ERROR PROCESSING STORED CALL DATA:", e);
          localStorage.removeItem('pending_call_data');
        }
      }
    } catch (e) {
      console.error("❌ ERROR CHECKING PENDING CALL NOTIFICATIONS:", e);
    }
  };

  useEffect(() => {
    setCall(userDetail.call);
  }, [userDetail.call])

  useEffect(() => {
    window.onfocus = function () { 
      setIsTabActive(true);
   }; 
   
   window.onblur = function () { 
     setIsTabActive(false);
   }; 

    const onBeforeUnload = (ev: any) => {
      hangUpOrRejectCall();
    }

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, []);

  const hangUpOrRejectCall = () => { 
    if (userDetail.call && typeof userDetail.call.hangUp === 'function') {
      userDetail.call.hangUp({forEveryone : true}).then();
    } else {
      if (userDetail.incomingCall && typeof userDetail.incomingCall.reject === 'function') {
        userDetail.incomingCall.reject().then();
      }
    }
  }

  const getunreadCount = () => {
    const { dispatch } = props;
    dispatch(getUnReadAlldata())
      .then((res: any) => {
        // setCount(res?.data?.data);
        dispatch(set_Chat_Count(res?.data?.data));
      })
      .catch((err: any) => {});
  };

  async function dropTheCall(message: EventSignalRModel<CallNotificationModel>) {
    const { dispatch } = props;
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    
    if (message.data 
      && (userRole == UserRoleEnum.ServiceProvider && message.data.SPId && spProfiles.indexOf(message.data.SPId) >= 0
      || userRole == UserRoleEnum.User && message.data.UserId == userProfile.id)) {

        if (message.data.CallType && getCallType(message.data.CallType) == CallTypeEnum.PhoneCall) {
          dispatch(set_Phone_Calling(false));
        }

        hangUpOrRejectCall();
        if (window.location.pathname.indexOf('/outgoing-call') >= 0 
        || window.location.pathname.indexOf('/incoming-call') >= 0) {
          if (message.broadcastType == BroadcastTypeEnum.BlockedDuringCall) {
              
            let role = 'user';
            if (userRole == UserRoleEnum.User) {
              role = 'consultant';
            }

            navigate(`/${role}/chat`);
          }
          navigate(-1);
        }
      }
  }

  // Force drop the call if has issue after 3s
  const handleCallDisconnected = (message: EventSignalRModel<CallNotificationModel>) => {
    setTimeout(() => {
      dropTheCall(message);
    }, 3000);
  }

  const handleCallNotification = (message: EventSignalRModel<CallNotificationModel>) => {
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
  
    if (message.data) {
      switch (message.broadcastType) {
        case BroadcastTypeEnum.CallDisconnected:
          handleCallDisconnected(message);
          break;
        case BroadcastTypeEnum.CallDisconnecting:
          handleCallDisconnecting(message);
          break;
        case BroadcastTypeEnum.InsufficientCredit:
          handleInsufficientCredit(message);
          break;
        case BroadcastTypeEnum.CallMissed:
          handleMissedCallSignalR(message);
          break;
        case BroadcastTypeEnum.BlockedDuringCall:
          handleCallDisconnecting(message);
          break;
        default:
          break;
      }
    }
  }

  const handleCallDisconnecting = async (message: EventSignalRModel<CallNotificationModel>) => {
    dropTheCall(message);
  }

  const handleInsufficientCredit = async (message: EventSignalRModel<CallNotificationModel>) => {
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    
    if (message.data) {
      if (message.data.CallType && getCallType(message.data.CallType) == CallTypeEnum.PhoneCall) {
        if (userRole == UserRoleEnum.User && message.data?.UserId == userProfile.id) {
          toast.error("Your call has been disconnected since you do not have the minimum amount of credits needed. Please top up to continue.", {
            theme: "colored",
            autoClose: 3000,
          });
        }
      } else {
        handleCallDisconnected(message);
      }
    }
  }

  const handleMissedCallSignalR = async (message: EventSignalRModel<CallNotificationModel>) => {
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    
    if (message.data && (userRole == UserRoleEnum.ServiceProvider && message.data.SPId && spProfiles.indexOf(message.data.SPId) >= 0)) {
        // logoutData();
      }
  }

  const handleSignalRNotification = async (message: EventSignalRModel<any>) => {
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;

    if (message.data) {
      switch (message.broadcastType) {
        case BroadcastTypeEnum.ExpiredToken:
          const data = message.data as string[];
          if (data && (data.filter(id=> spProfiles.indexOf(id) >= 0).length > 0 || 
                        data.filter(id=> id == userProfile.id).length > 0)) {
            logoutData();
          }
          break;
        case BroadcastTypeEnum.NewInboxMessage:
          break;
        case BroadcastTypeEnum.UserStatus:
          break;
        case BroadcastTypeEnum.BlockedUsers:
          // if (message.data) {
          //   const data1 = new ValueModel(message.data) ;
          //   let role = 'user';
          //   if (userRole == UserRoleEnum.User) {
          //     role = 'consultant';
          //   }

          //   if (!!data1.value && spProfiles.indexOf(data1.value) >= 0) {
          //     alert("You have been blocked by the user");
          //     navigate(`/${role}/home`);
          //     break;
          //   }

          //   if (data1.value && data1.value == userProfile.id) {
          //     navigate(`/${role}/home`);
          //   }
          // }
          break;
        default:
          //
          break;
        
      }
    }
  }

  const initNotification = () => {
    if (("Notification" in window)) {
      try {
        if (Notification.permission !== "granted") {
          Notification.requestPermission().then((permission) => {
            console.log(permission);
          }, (err) => {
            console.log(err);
          });
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      // Check if the browser supports notifications
      console.log("This browser does not support notification");
    }    
  }

  const initSignalRConnection = () => {
    const { dispatch } = props;
    const connection = getConnection();
    dispatch(set_Connection(connection));
    setHubConnection(connection);
    connection.on(BroadcastTargetEnum.Notification, handleSignalRNotification);
    connection.on(BroadcastTargetEnum.CallNotification, handleCallNotification);

    connection.start().then(() => {
      console.log('Hub connection started');
    }, (err) => {
      console.log(err);
    });
  }

  const initCall = (profile: any, communicationToken: string, communicationUserId: string) => {
    const { dispatch } = props;
    const tokenCredential = new AzureCommunicationTokenCredential(communicationToken);
    const userIdentifier = fromFlatCommunicationIdentifier(communicationUserId) as CommunicationUserIdentifier;
    
    const statefulCallClient = createStatefulCallClient({
      userId: userIdentifier,
    });

    statefulCallClient.createCallAgent(tokenCredential, { displayName: profile.username}).then((callAgent: CallAgent) => {
      subscribeIncomingCall(profile, callAgent, statefulCallClient, userIdentifier, tokenCredential);
    });

    subscribeIncomingMessage(tokenCredential, communicationUserId, profile);
  }

  const userInit = (communicationToken: string, communicationUserId: string) => {
    const { dispatch } = props;

    const tokenCredential = new AzureCommunicationTokenCredential(communicationToken);
    const userIdentifier = fromFlatCommunicationIdentifier(communicationUserId) as CommunicationUserIdentifier;
    const threadId = localStorage.getItem(LOCALSTORE.communicationIdentifier.threadId);

    dispatch(set_Token_Credential(tokenCredential));
    dispatch(set_User_Identifier(userIdentifier));
    dispatch(set_Thread_Id(threadId))

    const statefulCallClient = createStatefulCallClient({
      userId: userIdentifier,
    });
    statefulCallClient.createCallAgent(tokenCredential, { displayName: userProfile.username }).then((callAgent: CallAgent) => {
      dispatch(set_Call_Client(statefulCallClient));
      dispatch(set_Call_Agent(callAgent));
    });
    subscribeIncomingMessage(tokenCredential, communicationUserId, null);
  }

  const getProfiles = () => {
    const { dispatch } = props;
    dispatch(getSPProfileList()).then((result: any) => {      
      result.data.forEach((p: any) => {
        spProfiles.push(p.id);
        initCall(p, p.communicationIdentifier.token, p.communicationIdentifier.user_id);
      });
    })
  }
  
  const updateCredit = () => {
    const { dispatch } = props;
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    let userId;

    if (userRole == UserRoleEnum.ServiceProvider) 
      userId = accountData.id
    else   
      userId = userProfile.id

    if(userId || userDetail?.totalCredit?.accountId) {
      dispatch(getTotalCredit(userId ? userId : userDetail?.totalCredit?.accountId)).then((credit: any) => {
        dispatch(set_Total_Credit(credit?.data))
      })
    }
  };

  const logoutData = () => {
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    const {dispatch} = props;
    window.localStorage.clear();
    dispatch(reset_States(null));
    persistDispatch(reset_azure_communication_data())
    
    if (userRole == UserRoleEnum.ServiceProvider) {
      window.location.href = "/login";
    } else {
      window.location.href = "/login";
    }    
  };

  const validate = (communicationToken: string, communicationUserId: string, expiredOn: string | null) => {
    if (communicationToken == null || communicationUserId == null) {
      toast.error("Communication Id not found, please contact to admin for supporting", { theme: "colored", autoClose: 3000 });
      logoutData();
      return;
    }

    if (!expiredOn) {
      logoutData();
    } else {
      const expiredDate = new Date(expiredOn);
      const now = new Date();
      if (expiredDate.getTime() - now.getTime() <= 0) {
        logoutData();
      }
    }
  }

  const subscribeIncomingMessage = (tokenCredential: AzureCommunicationTokenCredential, communicationUserId: string, profile: any) => {
    const { dispatch } = props;
    dispatch(getEndpoint())
    .then( async (res: any) => {
      dispatch(set_endpoint(res.data.data));
      const endpoint = res.data.data;
      const chat = new ChatClient(endpoint, tokenCredential);
      await chat.startRealtimeNotifications();

      chat.on("chatMessageReceived", (event) =>{ 
        handleChatMessageReceived(event, communicationUserId, profile)
        const sender = event.sender as CommunicationUserIdentifier;
        const recipient = event.recipient as CommunicationUserIdentifier;
        if (Notification.permission === "denied" && sender.communicationUserId !== recipient.communicationUserId) {
        // if (Notification.permission === "denied") {
          toast.info(
            `New message from ${event.senderDisplayName}: ${event.message}`
          );
        }
      });
      chat.on("chatMessageEdited", handleChatMessageUpdated);
    });
  }
  
  function handleChatMessageReceived(event: ChatMessageReceivedEvent, communicationUserId: string, profile: any) {
    // updateNewMessageToChatList(event, props, userDetail.chatThreads, userDetail.chatData);
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    const sender = event.sender as CommunicationUserKind;

    getunreadCount();
    
    if (sender.communicationUserId == communicationUserId) {
      // Update Credit to SPs when they finish a round of chat
      if (userRole == UserRoleEnum.ServiceProvider) {
        updateCredit();
      }
      return;
    }
    
    playRingTone(RingtoneEnum.MessageIncoming).then();
    
    // Update Credit to SPs when they get message with metadata (GIFT | MEDIA)
    // OR Update Credit to Users when they finish a round of chat 
    if (userRole == UserRoleEnum.ServiceProvider && Object.getOwnPropertyNames(event.metadata).length > 0
    || userRole == UserRoleEnum.User) {
      updateCredit();
    }

    if (profile) {
      notifyMe(`${event.senderDisplayName} to ${profile.username}: ${event.message}`);
    } else {
      notifyMe(`${event.senderDisplayName}: ${event.message}`);
    }
  }
  
  function notifyMe(message: string) {
    if (!("Notification" in window)) {
      console.log("This browser does not support notification");
    } else if (Notification.permission === "granted") {
      serviceWorkerRegistration.showNotification(message);
    }
  }

  function handleChatMessageUpdated(event: ChatMessageReceivedEvent) {
    // updateNewMessageToChatList(event, props, userDetail.chatThreads, userDetail.chatData);
    const userRole = localStorage.getItem(LOCALSTORE.role) as any;
    
    // Update Credit to SPs when they get message with metadata
    if (userRole == UserRoleEnum.ServiceProvider && Object.getOwnPropertyNames(event.metadata).length > 0) {
      updateCredit();
    }
  }

  const handleEndCall = () => {
    stopRingTone(RingtoneEnum.Incoming);
  }

  // Listen for incoming call detection events from native layer
  const setupIncomingCallDetectionListener = () => {
    console.log("Setting up incoming call detection listener");
    
    // Listen for the incomingCallDetection event from native layer
    window.addEventListener('incomingCallDetection', async (event: any) => {
      try {
        console.log("🎯🎯🎯 INCOMING CALL DETECTION EVENT RECEIVED 🎯🎯🎯", event);
        
        let callData;
        if (event.detail) {
          try {
            callData = JSON.parse(event.detail);
          } catch (e) {
            callData = event.detail;
          }
        } else {
          callData = event;
        }
        
        if (!callData || (!callData.callConnectionId && !callData.incomingCommunicationUserId)) {
          console.error("❌ INCOMING CALL DETECTION EVENT MISSING REQUIRED DATA");
          return;
        }
        
        console.log("🎯 Incoming call detection data:", callData);
        
        // Get profile from local storage or the event data
        const userRole = localStorage.getItem(LOCALSTORE.role) as any;
        
        if (userRole === UserRoleEnum.ServiceProvider) {
          // For service providers - need to find correct profile
          await handleServiceProviderCallDetection(callData);
        } else {
          // For regular users
          await handleUserCallDetection(callData);
        }
      } catch (error) {
        console.error("❌ ERROR HANDLING INCOMING CALL DETECTION EVENT:", error);
      }
    });
    
    // Also listen for direct API call results from the JS layer
    window.addEventListener('incomingCallDetected', async (event: any) => {
      try {
        console.log("🔥🔥🔥 DIRECT API CALL RESULT EVENT RECEIVED 🔥🔥🔥", event);
        
        if (!event.detail) {
          console.error("❌ DIRECT API CALL EVENT MISSING DETAIL DATA");
          return;
        }
        
        // Parse the caller data from the direct API call
        let caller: any;
        try {
          caller = JSON.parse(event.detail);
        } catch (e) {
          console.error("❌ ERROR PARSING DIRECT API CALL RESULT:", e);
          return;
        }
        
        console.log("🔥 Direct API call result data:", caller);
        
        if (!caller) {
          console.error("❌ DIRECT API CALL RESULT IS EMPTY");
          return;
        }
        
        // Save current profile ID to localStorage for future direct API calls
        if (userDetail?.user_profile?.id) {
          localStorage.setItem('currentProfileId', userDetail.user_profile.id);
          console.log("💾 Saved current profile ID to localStorage:", userDetail.user_profile.id);
        }
        
        // Get user role from localStorage
        const userRole = localStorage.getItem(LOCALSTORE.role) as any;
        
        // Process the call with the caller data and appropriate profile
        if (userRole === UserRoleEnum.ServiceProvider) {
          // For service providers, find the correct profile
          if (userDetail.spProfiles?.length > 0) {
            // Find the first available profile or the matching one
            const matchingProfile = userDetail.spProfiles.find((p: any) => p.id === caller.spId) || userDetail.spProfiles[0];
            processDetectedCall(caller, matchingProfile);
          } else {
            console.error("❌ NO SERVICE PROVIDER PROFILES AVAILABLE");
          }
        } else {
          // For regular users, use the current user profile
          processDetectedCall(caller, userDetail.user_profile);
        }
      } catch (error) {
        console.error("❌ ERROR HANDLING DIRECT API CALL RESULT EVENT:", error);
      }
    });
    
    // Add a listener for pushNotificationActionPerformed to make direct API calls
    window.addEventListener('pushNotificationActionPerformed', async (event: any) => {
      try {
        console.log("🔔🔔🔔 PUSH NOTIFICATION ACTION EVENT RECEIVED IN CALL AGENT 🔔🔔🔔", event);
        
        let notificationData;
        try {
          // Parse data if it's a string
          if (typeof event.detail === 'string') {
            notificationData = JSON.parse(event.detail);
          } else {
            notificationData = event.detail;
          }
          
          // Extract the notification data
          const notification = notificationData?.notification;
          const data = notification?.data || notificationData?.data || {};
          
          console.log("📱 Extracted notification data:", data);
          
          // Check if this is a call notification
          if (data?.type === 'CallConnecting') {
            console.log("☎️ CallConnecting notification detected in call-agent - will make API call");
            
            // Set a flag to indicate this call is from a push notification
            localStorage.setItem('call_from_push_notification', 'true');
            
            // Get the current profile ID
            const userRole = localStorage.getItem(LOCALSTORE.role) as any;
            const profileId = userRole === UserRoleEnum.ServiceProvider 
              ? (userDetail.spProfiles && userDetail.spProfiles.length > 0 ? userDetail.spProfiles[0].id : null)
              : userDetail?.user_profile?.id;
            
            if (profileId) {
              // Make call detection API call directly from call-agent component
              console.log("📞 Making call detection API call with profileId:", profileId);
              
              // Define interface for request body
              interface CallDetectionRequestBody {
                callConnectionId: string;
                incomingCommunicationUserId: string;
                [key: string]: any; // Allow additional properties
              }
              
              // Create properly typed request body
              const body: CallDetectionRequestBody = {
                callConnectionId: data.callConnectionId || "",
                incomingCommunicationUserId: data.senderId || ""
              };
              
              console.log("📞 Call detection API body:", body);
              
              // Make API call via homeService
              const { dispatch } = props;
              try {
                const result = await dispatch(detectIncomingCall(body, profileId));
                
                if (result?.data?.isSuccess) {
                  console.log("✅ Call detection API success:", result.data);
                  // Process the caller data
                  const caller = result.data.data;
                  
                  // Get the appropriate profile
                  if (userRole === UserRoleEnum.ServiceProvider) {
                    const matchingProfile = userDetail.spProfiles?.find((p: any) => p.id === profileId) || 
                                          (userDetail.spProfiles && userDetail.spProfiles.length > 0 ? userDetail.spProfiles[0] : null);
                    
                    if (matchingProfile) {
                      processDetectedCall(caller, matchingProfile);
                    } else {
                      console.error("❌ No matching SP profile found");
                    }
                  } else {
                    processDetectedCall(caller, userDetail.user_profile);
                  }
                } else {
                  console.error("❌ Call detection API failed:", result?.data?.message);
                }
              } catch (error) {
                console.error("❌ Error making call detection API call:", error);
              }
            } else {
              console.error("❌ No profile ID available for API call");
            }
          }
        } catch (error) {
          console.error("❌ Error processing notification data:", error);
        }
      } catch (error) {
        console.error("❌ ERROR HANDLING PUSH NOTIFICATION ACTION EVENT:", error);
      }
    });
    
    console.log("Incoming call detection listener setup completed");
  };
  
  // Handle service provider call detection
  const handleServiceProviderCallDetection = async (callData: any) => {
    const { dispatch } = props;
    console.log("Handling service provider call detection:", callData);
    
    try {
      // Load profiles if needed
      if (spProfiles.length === 0) {
        console.log("Loading SP profiles for call detection");
        const result = await dispatch(getSPProfileList());
        
        if (result && result.data) {
          for (const profile of result.data) {
            // Try call detection for each profile
            try {
              const body = {
                callConnectionId: callData.callConnectionId,
                incomingCommunicationUserId: callData.incomingCommunicationUserId,
              };
              
              console.log(`Attempting call detection for profile ${profile.id}`);
              const res = await dispatch(detectIncomingCall(body, profile.id));
              
              if (res?.data?.isSuccess) {
                console.log("✅ CALL DETECTION SUCCESSFUL!");
                const caller: PublicProfileResponseModel = res.data.data;
                processDetectedCall(caller, profile);
                return; // Exit after finding the correct profile
              }
            } catch (error) {
              console.log(`Call detection failed for profile ${profile.id}:`, error);
            }
          }
        }
      } else {
        // Try with existing profiles
        for (let i = 0; i < spProfiles.length; i++) {
          const profileId = spProfiles[i];
          try {
            const body = {
              callConnectionId: callData.callConnectionId,
              incomingCommunicationUserId: callData.incomingCommunicationUserId,
            };
            
            console.log(`Attempting call detection for profile ${profileId}`);
            const res = await dispatch(detectIncomingCall(body, profileId));
            
            if (res?.data?.isSuccess) {
              console.log("✅ CALL DETECTION SUCCESSFUL!");
              const caller: PublicProfileResponseModel = res.data.data;
              
              // Find matching profile from context
              const matchingProfile = userDetail.spProfiles?.find((p: any) => p.id === profileId);
              if (matchingProfile) {
                processDetectedCall(caller, matchingProfile);
                return; // Exit after finding the correct profile
              }
            }
          } catch (error) {
            console.log(`Call detection failed for profile ${profileId}:`, error);
          }
        }
      }
      
      console.error("❌ CALL DETECTION FAILED FOR ALL PROFILES");
    } catch (error) {
      console.error("❌ ERROR IN SERVICE PROVIDER CALL DETECTION:", error);
    }
  };
  
  // Handle user call detection
  const handleUserCallDetection = async (callData: any) => {
    const { dispatch } = props;
    console.log("Handling user call detection:", callData);
    
    try {
      const userProfile = userDetail.user_profile;
      if (!userProfile?.id) {
        console.error("❌ USER PROFILE NOT AVAILABLE FOR CALL DETECTION");
        return;
      }
      
      const body = {
        callConnectionId: callData.callConnectionId,
        incomingCommunicationUserId: callData.incomingCommunicationUserId,
      };
      
      const res = await dispatch(detectIncomingCall(body, userProfile.id));
      
      if (res?.data?.isSuccess) {
        console.log("✅ USER CALL DETECTION SUCCESSFUL!");
        const caller: PublicProfileResponseModel = res.data.data;
        
        // Use current user for profile
        processDetectedCall(caller, userProfile);
      } else {
        console.error("❌ USER CALL DETECTION FAILED:", res?.data?.message);
      }
    } catch (error) {
      console.error("❌ ERROR IN USER CALL DETECTION:", error);
    }
  };
  
  // Process detected call - common for both user types
  const processDetectedCall = (caller: PublicProfileResponseModel, profile: any) => {
    const { dispatch } = props;
    console.log("Processing detected call - caller:", caller, "profile:", profile);
    
    try {
      // Store the call connection ID in localStorage for later use in accept/reject
      if (caller?.communication?.callConnecting?.callConnectionId) {
        localStorage.setItem('current_call_id', caller.communication.callConnecting.callConnectionId);
        console.log(`Stored call connection ID: ${caller.communication.callConnecting.callConnectionId}`);
      }
      
      // Ensure we have Azure credentials
      const communicationToken = localStorage.getItem(LOCALSTORE.communicationIdentifier.token) as any;
      const communicationUserId = localStorage.getItem(LOCALSTORE.communicationIdentifier.userId) as any;
      
      if (!communicationToken || !communicationUserId) {
        console.error("❌ COMMUNICATION CREDENTIALS NOT AVAILABLE");
        return;
      }
      
      const tokenCredential = new AzureCommunicationTokenCredential(communicationToken);
      const userIdentifier = fromFlatCommunicationIdentifier(communicationUserId) as CommunicationUserIdentifier;
      
      // Create Azure call client
      const statefulCallClient = createStatefulCallClient({
        userId: userIdentifier,
      });
      
      // Store all the necessary information
      dispatch(set_Token_Credential(tokenCredential));
      dispatch(set_User_Identifier(userIdentifier));
      
      // Create call agent manually for this detection
      statefulCallClient.createCallAgent(tokenCredential, { displayName: profile.username }).then((agent: CallAgent) => {
        dispatch(set_Call_Agent(agent));
        dispatch(set_Call_Client(statefulCallClient));
        
        // We don't have an IncomingCall object, so create a synthetic one or handle differently
        // For now, we'll just show the UI without an actual IncomingCall object
        setIncomingCallUser(caller);
        
        // Set call type
        const ct = CallTypeEnum[caller?.communication?.callConnecting?.callType as keyof typeof CallTypeEnum];
        setCallType(ct);
        setCurrentSPProfile(profile);
        setIncomingCallDialog(true);
        
        // Check if this call was initiated from a push notification
        const isFromPushNotification = localStorage.getItem('call_from_push_notification') === 'true';
        
        // Only play ringtone if this is NOT from a push notification (to avoid duplicate sounds)
        if (!isFromPushNotification) {
          console.log("🔊 Playing ringtone for normal call");
          playRingTone(RingtoneEnum.Incoming).then();
        } else {
          console.log("🔇 Skipping ringtone for call from push notification");
          // Clear the flag
          localStorage.removeItem('call_from_push_notification');
        }
        
        // Show notification
        notifyMe(
`${caller.username} is calling to ${profile.username}
via ${ct == CallTypeEnum.VideoCallOneWay ? "One Way Video Call" : (ct == CallTypeEnum.VideoCallTwoWay ? "Video Call" : "Voice Call")}`);
      });
    } catch (error) {
      console.error("❌ ERROR PROCESSING DETECTED CALL:", error);
    }
  };

  // Original incoming call handler
  const incomingCallListener = async (profile: any, incomingC: IncomingCall, agent: CallAgent, statefulCallClient: StatefulCallClient,
    userIdentifier: CommunicationUserIdentifier,
    tokenCredential: AzureCommunicationTokenCredential) => {
    const { dispatch } = props;
    try {
      const identifier =  incomingC.callerInfo.identifier as CommunicationUserKind
      const body = {
        callConnectionId: incomingC.id,
        incomingCommunicationUserId: identifier.communicationUserId,
      };
      
      incomingC.on("callEnded", handleEndCall);

      dispatch(detectIncomingCall(body, profile.id))
        .then(async (res: any) => {
          if (!res.data.isSuccess) {
            resetData();
            await incomingC.reject();
            incomingC.off("callEnded", handleEndCall);
            toast.error(res.data.message, {
                theme: "colored",
                autoClose: 3000,
            });
            return;
          }

          const caller: PublicProfileResponseModel = res.data.data;
          setIncomingCallUser(caller);

          dispatch(set_Token_Credential(tokenCredential));
          dispatch(set_User_Identifier(userIdentifier));
          dispatch(set_Call_Agent(agent));
          dispatch(set_Call_Client(statefulCallClient));
          dispatch(set_Incoming_Call(incomingC));
          const ct = CallTypeEnum[caller?.communication?.callConnecting?.callType as keyof typeof CallTypeEnum];
          setCallType(ct);
          setCurrentSPProfile(profile);
          setIncomingCallDialog(true);
          
          notifyMe(
`${caller.username} is calling to ${profile.username}
via ${ct == CallTypeEnum.VideoCallOneWay ? "One Way Video Call" : (ct == CallTypeEnum.VideoCallTwoWay ? "Video Call" : "Voice Call")}`);
        })
        .catch(async (err: any) => {
          resetData();
          await incomingC.reject();
          incomingC.off("callEnded", handleEndCall);
          toast.error(err.data.message, {
              theme: "colored",
              autoClose: 3000,
          });
        });
      
    } catch (error: any) {
      resetData();
      toast.error(error, { theme: "colored", autoClose: 3000 });
      await incomingC.reject();
      incomingC.off("callEnded", handleEndCall);
    }
  }

  function callEndListener() {
    resetData();
  }

  const subscribeIncomingCall = (profile: any, agent: CallAgent, 
    statefulCallClient: StatefulCallClient,
    userIdentifier: CommunicationUserIdentifier,
    tokenCredential: AzureCommunicationTokenCredential) => {
    // Listen for an incoming call to accept.
    agent.on("incomingCall", (args) => {
      incomingCallListener(profile, args.incomingCall, agent, statefulCallClient, userIdentifier, tokenCredential);
      args.incomingCall.on("callEnded", callEndListener);
    });
  };

  const onAcceptCall = (profile: any, isVideoToggle?: boolean) => {
    const { dispatch } = props;
    setIncomingCallDialog(false);
    stopRingTone(RingtoneEnum.Incoming);
    
    // Get call ID from incomingCall object or stored callConnectionId from notification
    const callId = incomingCall?.id || localStorage.getItem('current_call_id');
    
    if (!callId) {
      console.error("❌ NO CALL ID AVAILABLE FOR ACCEPTING CALL");
      toast.error("Unable to accept call - missing call ID", { theme: "colored", autoClose: 3000 });
      resetData();
      return;
    }
    
    console.log(`Accepting call with ID: ${callId}`);
    
    dispatch(acceptIncomingCall(callId, incomingCallUser?.id, profile.id, callType))
      .then(async (res: any) => {
        if (res?.data?.isSuccess) {
          console.log("✅ CALL ACCEPTED SUCCESSFULLY");
          const acceptIncomingCall : AcceptIncomingCallModel = res?.data.data;
          dispatch(set_toggle_video_call(isVideoToggle));
          dispatch(set_chat_data(acceptIncomingCall.callConnectedUser?.room));
          dispatch(set_call_connected(acceptIncomingCall.callConnectedUser));
          dispatch(set_Thread_Id(acceptIncomingCall.callConnectedUser?.room?.threadId));
          
          let callTypeStr = '';
          if (incomingCallUser?.communication?.callConnecting?.callType) {
            const callTypeEnum = CallTypeEnum[(incomingCallUser.communication.callConnecting.callType) as keyof typeof CallTypeEnum];
            if (callTypeEnum == CallTypeEnum.VideoCallTwoWay) {
              callTypeStr = 'video';
            } else if (callTypeEnum == CallTypeEnum.VideoCallOneWay) {
              callTypeStr = 'video-one-way';
            } else if (callTypeEnum == CallTypeEnum.AudioCall) {
              callTypeStr = 'voice';
            } 
          }

          // If we have an actual IncomingCall object, unregister listeners
          if (incomingCall) {
            incomingCall.off("callEnded", callEndListener);
          }

          let role = 'user';
          if (incomingCallUser?.role == UserRoleEnum.User) {
            role = 'consultant';
          }

          console.log(`Navigating to call screen: /${role}/incoming-call/${callTypeStr}/${acceptIncomingCall.callConnectedUser?.callerUser?.id}`);
          navigate(`/${role}/incoming-call/${callTypeStr}/${acceptIncomingCall.callConnectedUser?.callerUser?.id}`);
        } else {
          console.error("❌ CALL ACCEPTANCE FAILED:", res?.data?.message);
          toast.error(res?.data?.message || "Failed to accept call", { theme: "colored", autoClose: 3000 });
          
          // If we have an actual IncomingCall object, reject it
          if (incomingCall && typeof incomingCall.reject === 'function') {
            incomingCall.reject();
          }
          
          resetData();
        }
      })
      .catch((err: any) => {
        console.error("❌ ERROR ACCEPTING CALL:", err);
        toast.error(err?.data?.message || "Error accepting call", { theme: "colored", autoClose: 3000 });
        
        // If we have an actual IncomingCall object, reject it
        if (incomingCall && typeof incomingCall.reject === 'function') {
          incomingCall.reject();
        }
        
        resetData();
      });
  };

  const onRejectCall = async () => {
    stopRingTone(RingtoneEnum.Incoming);
    
    if (!incomingCallUser) {
      toast.error("Cannot detect caller user", { theme: "colored", autoClose: 3000 });
      resetData();
      return;
    }
    
    // Only try to use the reject method if we have an actual IncomingCall object
    if (incomingCall && typeof incomingCall.reject === 'function') {
      try {
        await incomingCall.reject();
        incomingCall.off("callEnded", handleEndCall);
      } catch (error) {
        console.error("❌ ERROR REJECTING CALL:", error);
      }
    } else {
      console.log("No incomingCall object to reject - call was from notification");
    }
    
    resetData();
  };

  const resetData = () => {
    const { dispatch } = props;
    dispatch(reset_Call_State(null));
    dispatch(set_Call_Agent(null));
    setIncomingCallDialog(false);
  }

  return (
    <div className=" w-full bg-center">
      <ToastContainer />
      <audio id="message-tone" hidden>
        <source type="audio/mpeg"></source>
      </audio>
      <audio id="writing-a-text-message-tone" hidden>
        <source type="audio/mpeg"></source>
      </audio>
      <audio id="top-up-alert" hidden>
        <source type="audio/mpeg"></source>
      </audio>
      <audio id="outgoing-tone" hidden>
        <source type="audio/mpeg"></source>
      </audio>
      <audio hidden={true} id="incoming-tone">
        <source type="audio/mpeg"></source>
      </audio>
      {isIncomingCall && callType != CallTypeEnum.VideoCallTwoWay && (
        <IncomingAudioCall
          callerName={incomingCallUser?.username}
          calleeName={currentSPProfile?.username}
          avatar={incomingCallUser?.profileImageUrl}
          currentSPProfile={currentSPProfile}
          alertText={callType == CallTypeEnum.VideoCallOneWay ? "Incoming One Way Video Call" : "Incoming Voice Call"}
          onClickAccept={onAcceptCall}
          onClickReject={onRejectCall}
        />
      )}
      {isIncomingCall && callType == CallTypeEnum.VideoCallTwoWay && (
        <IncomingVideoCall
          callerName={incomingCallUser?.username}
          calleeName={currentSPProfile?.username}
          avatar={incomingCallUser?.profileImageUrl}
          currentSPProfile={currentSPProfile}
          alertText={"Incoming Video Call"}
          onClickAccept={onAcceptCall}
          onClickReject={onRejectCall}
        />
      )}
      </div>
  );
};

export default connect()(AzureCallAgent);
